/*
  Add here your own custom javascript codes
*/

/* GemPages -> Falcon Pro cart drawer bridge.
   GemPages posts to /cart/add.js itself and never reaches the theme's
   product-form handler, so the drawer stays closed. This listens for the
   GemPages success event (and the "Open cart drawer" action if that is
   ever selected), re-renders Falcon's cart sections and opens the drawer. */
(function () {
  var busy = false;
  function openFalconCart() {
    if (busy) return;
    var cc = document.querySelector('cart-component');
    var drawer = document.querySelector('#cart-drawer');
    if (!cc || !drawer) return;
    busy = true;
    var sections = (cc.sectionsToRender || ['cart-badge', 'cart-drawer']).join(',');
    fetch(window.location.pathname + '?sections=' + sections, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var live = document.querySelector('cart-component');
        if (live && typeof live.renderCart === 'function') live.renderCart(data);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var d = document.querySelector('#cart-drawer');
        if (d && !d.open && typeof d.showModal === 'function') d.showModal();
      });
  }
  window.GPF = window.GPF || {};
  window.GPF.openCartDrawer = function () { openFalconCart(); };
  window.addEventListener('gp:add-to-cart-success', function () { openFalconCart(); });
})();
